<template>
  <div class="main">
    <div class="content-wrap">
      <div>
        <div v-for="t in days" :key="t">
          <div class="time-header">
            <p>{{unixTime2DateText(t)}}</p>
          </div>
          <div>
            <div v-for="res in reservations[t]" :key="res.rid" class="reservation-list">
              <div style="text-align:left;">
                <span class="time">{{unixTime2TimeText(res.time)}}</span>
                <span class="name">{{res.name}}</span>
              </div>
              <!-- order loop -->
              <template v-for="(vals, key) in res.order" :keys="key">
                <div v-for="(order, idx) in vals" :key="idx">
                  <div class="columns is-multiline is-gapless is-mobile orders">
                    <div class="column order">
                      <div>
                        <p class="menu-name">
                          <span>{{order.name}}</span>
                          <span v-if="order.cnt>1">x{{order.cnt}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="column is-half price">
                      <p class="menu-price">￥{{order.price*order.cnt}}</p>
                    </div>
                    <div v-for="(op, opid) in order.options" :key="opid">
                      <template v-if="isShowOption(opid)">
                        <div v-for="(cval, cid) in op.value" :key="cid">
                          <div class="column is-half">{{cval.name}}</div>
                          <div
                            class="column is-half"
                          >￥{{getChoicePrice(order.mid, opid, cid, res.menu_type)}}</div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <!-- reservation price -->
              <div class="columns is-mobile">
                <div class="column sum-price-text">合計</div>
                <div class="column sum-price">￥{{getPriceSum(res)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { firebaseApp, shopDB, userDB } from "../firebaseInit";
// import firebase from "firebase";
import async from "async";

export default {
  name: "SalesList",
  data() {
    return {
      dataPoint: { take: "menus", delivery: "menus" }
    };
  },
  methods: {
    toEdit(res) {
      // this.$router.push({name: 'editbill', params: {reservation: res}});
    },
    getMenuNum(customerId) {
      // return this.$store.getters.menuNumSum(customerId);
    },
    unixTime2DateText(t) {
      return moment(t * 1000)
        .tz("Asia/Tokyo")
        .format("YYYY年MM月DD日");
    },
    unixTime2TimeText(t) {
      return moment(t * 1000)
        .tz("Asia/Tokyo")
        .format("HH:mm");
    },
    isShowOption(opid) {
      return false;
      // if (
      //   this.$store.state.conf[opid] &&
      //   this.$store.state.conf[opid].isShowInSale === 1
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    getPriceSum(reservation) {
      let priceAll = 0;
      for (let uid in reservation.order) {
        for (let orderIdx in reservation.order[uid]) {
          const unitPrice = reservation.order[uid][orderIdx].price;
          const cnt = reservation.order[uid][orderIdx].cnt;
          priceAll += unitPrice * cnt;
        }
      }
      return priceAll;
    },
    getChoicePrice(mid, opid, cid, menuType) {
      if (menuType === "take") {
        try {
          return this.$store.state.takeMenus[mid].options[opid].choices[cid]
            .price;
        } catch (e) {
          return 0;
        }
      } else {
        // TODO:
      }
    }
  },
  computed: {
    days() {
      return this.$store.getters.reservationDays;
    },
    rawReservs() {
      return this.$store.state.reservations;
    },
    reservations() {
      /* unixTime(日付別)がkeyのjson */
      const reservations = this.rawReservs;
      const formattedReservs = {};
      for (const rid in reservations) {
        const reservation = reservations[rid];
        reservation.rid = rid;
        const tKey = reservation.time - (reservation.time % 86400);
        const user = reservation.users[reservation.user_id];
        reservation.name = user.name;
        if (formattedReservs[tKey]) {
          formattedReservs[tKey].push(reservation);
        } else {
          formattedReservs[tKey] = [reservation];
        }
      }
      return formattedReservs;
    }
  },
  mounted() {}
};
</script>

<style scoped>
.main {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.content-wrap {
  width: 100%;
}

.main-header {
  text-align: left;
  font-size: 1.3em;
  margin: 5px 5px;
  padding-left: 1vw;
  height: 7vh;
  line-height: 7vh;
}

.time-header {
  background-color: #d8d8d8;
  color: #000000;
  text-align: left;
  padding-left: 30px;
}
.reservation-list {
  padding: 20px 30px;
  background-color: #ffffff;
  border-bottom: solid 0.2px #d8d8d8;
}
.reservation-list .orders {
  margin: 10px 0;
}
.reservation-list .name {
  color: #5a5a5a;
  padding-left: 30px;
}
.reservation-list .time {
  color: #a0a0a0;
}
.reservation-list .order {
  text-align: left;
  padding: 20px 0;
}
.reservation-list .price {
  text-align: right;
}
.reservation-list .menu-name {
  /* font-size: 2vw; */
}
.reservation-list .menu-price {
  /* font-size: 2vw; */
}
.reservation-list .course {
}
.reservation-list .amount {
}
.reservation-list .num {
  font-weight: bold;
  font-size: 2em;
}

.sum-price-text {
  text-align: left;
  font-weight: bold;
}
.sum-price {
  text-align: right;
  font-weight: bold;
}
.is-paid {
  background-color: gray;
}
</style>
